module.exports = __webpack_public_path__ + "static/media/vince_headshot.cf0c27ac.jpeg";